/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as FlowsRouteImport } from './routes/flows'
import { Route as DancefloorCommandsRouteImport } from './routes/dancefloor-commands'
import { Route as CompositionsRouteImport } from './routes/compositions'
import { Route as AvatarReviewRouteImport } from './routes/avatar-review'
import { Route as AccountRouteImport } from './routes/account'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StreamsIndexRouteImport } from './routes/streams.index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as StreamsStreamIdRouteImport } from './routes/streams.$streamId'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminTranscriptsRouteImport } from './routes/admin/transcripts'
import { Route as AdminSuperAdminRouteImport } from './routes/admin/super-admin'
import { Route as AdminStreamsRouteImport } from './routes/admin/streams'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminRecordingsRouteImport } from './routes/admin/recordings'
import { Route as AdminLiveMixerRouteImport } from './routes/admin/live-mixer'
import { Route as AdminDancefloorRouteImport } from './routes/admin/dancefloor'
import { Route as AdminChatRouteImport } from './routes/admin/chat'
import { Route as AdminChannelsRouteImport } from './routes/admin/channels'

const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const FlowsRoute = FlowsRouteImport.update({
  id: '/flows',
  path: '/flows',
  getParentRoute: () => rootRouteImport,
} as any)
const DancefloorCommandsRoute = DancefloorCommandsRouteImport.update({
  id: '/dancefloor-commands',
  path: '/dancefloor-commands',
  getParentRoute: () => rootRouteImport,
} as any)
const CompositionsRoute = CompositionsRouteImport.update({
  id: '/compositions',
  path: '/compositions',
  getParentRoute: () => rootRouteImport,
} as any)
const AvatarReviewRoute = AvatarReviewRouteImport.update({
  id: '/avatar-review',
  path: '/avatar-review',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StreamsIndexRoute = StreamsIndexRouteImport.update({
  id: '/streams/',
  path: '/streams/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const StreamsStreamIdRoute = StreamsStreamIdRouteImport.update({
  id: '/streams/$streamId',
  path: '/streams/$streamId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminTranscriptsRoute = AdminTranscriptsRouteImport.update({
  id: '/transcripts',
  path: '/transcripts',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSuperAdminRoute = AdminSuperAdminRouteImport.update({
  id: '/super-admin',
  path: '/super-admin',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminStreamsRoute = AdminStreamsRouteImport.update({
  id: '/streams',
  path: '/streams',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminRecordingsRoute = AdminRecordingsRouteImport.update({
  id: '/recordings',
  path: '/recordings',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminLiveMixerRoute = AdminLiveMixerRouteImport.update({
  id: '/live-mixer',
  path: '/live-mixer',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminDancefloorRoute = AdminDancefloorRouteImport.update({
  id: '/dancefloor',
  path: '/dancefloor',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminChatRoute = AdminChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminChannelsRoute = AdminChannelsRouteImport.update({
  id: '/channels',
  path: '/channels',
  getParentRoute: () => AdminRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/account': typeof AccountRoute
  '/avatar-review': typeof AvatarReviewRoute
  '/compositions': typeof CompositionsRoute
  '/dancefloor-commands': typeof DancefloorCommandsRoute
  '/flows': typeof FlowsRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/admin/channels': typeof AdminChannelsRoute
  '/admin/chat': typeof AdminChatRoute
  '/admin/dancefloor': typeof AdminDancefloorRoute
  '/admin/live-mixer': typeof AdminLiveMixerRoute
  '/admin/recordings': typeof AdminRecordingsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/streams': typeof AdminStreamsRoute
  '/admin/super-admin': typeof AdminSuperAdminRoute
  '/admin/transcripts': typeof AdminTranscriptsRoute
  '/admin/users': typeof AdminUsersRoute
  '/streams/$streamId': typeof StreamsStreamIdRoute
  '/admin/': typeof AdminIndexRoute
  '/streams/': typeof StreamsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/account': typeof AccountRoute
  '/avatar-review': typeof AvatarReviewRoute
  '/compositions': typeof CompositionsRoute
  '/dancefloor-commands': typeof DancefloorCommandsRoute
  '/flows': typeof FlowsRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/admin/channels': typeof AdminChannelsRoute
  '/admin/chat': typeof AdminChatRoute
  '/admin/dancefloor': typeof AdminDancefloorRoute
  '/admin/live-mixer': typeof AdminLiveMixerRoute
  '/admin/recordings': typeof AdminRecordingsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/streams': typeof AdminStreamsRoute
  '/admin/super-admin': typeof AdminSuperAdminRoute
  '/admin/transcripts': typeof AdminTranscriptsRoute
  '/admin/users': typeof AdminUsersRoute
  '/streams/$streamId': typeof StreamsStreamIdRoute
  '/admin': typeof AdminIndexRoute
  '/streams': typeof StreamsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/account': typeof AccountRoute
  '/avatar-review': typeof AvatarReviewRoute
  '/compositions': typeof CompositionsRoute
  '/dancefloor-commands': typeof DancefloorCommandsRoute
  '/flows': typeof FlowsRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/admin/channels': typeof AdminChannelsRoute
  '/admin/chat': typeof AdminChatRoute
  '/admin/dancefloor': typeof AdminDancefloorRoute
  '/admin/live-mixer': typeof AdminLiveMixerRoute
  '/admin/recordings': typeof AdminRecordingsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/streams': typeof AdminStreamsRoute
  '/admin/super-admin': typeof AdminSuperAdminRoute
  '/admin/transcripts': typeof AdminTranscriptsRoute
  '/admin/users': typeof AdminUsersRoute
  '/streams/$streamId': typeof StreamsStreamIdRoute
  '/admin/': typeof AdminIndexRoute
  '/streams/': typeof StreamsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/$'
    | '/account'
    | '/avatar-review'
    | '/compositions'
    | '/dancefloor-commands'
    | '/flows'
    | '/login'
    | '/register'
    | '/admin/channels'
    | '/admin/chat'
    | '/admin/dancefloor'
    | '/admin/live-mixer'
    | '/admin/recordings'
    | '/admin/settings'
    | '/admin/streams'
    | '/admin/super-admin'
    | '/admin/transcripts'
    | '/admin/users'
    | '/streams/$streamId'
    | '/admin/'
    | '/streams/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/account'
    | '/avatar-review'
    | '/compositions'
    | '/dancefloor-commands'
    | '/flows'
    | '/login'
    | '/register'
    | '/admin/channels'
    | '/admin/chat'
    | '/admin/dancefloor'
    | '/admin/live-mixer'
    | '/admin/recordings'
    | '/admin/settings'
    | '/admin/streams'
    | '/admin/super-admin'
    | '/admin/transcripts'
    | '/admin/users'
    | '/streams/$streamId'
    | '/admin'
    | '/streams'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/$'
    | '/account'
    | '/avatar-review'
    | '/compositions'
    | '/dancefloor-commands'
    | '/flows'
    | '/login'
    | '/register'
    | '/admin/channels'
    | '/admin/chat'
    | '/admin/dancefloor'
    | '/admin/live-mixer'
    | '/admin/recordings'
    | '/admin/settings'
    | '/admin/streams'
    | '/admin/super-admin'
    | '/admin/transcripts'
    | '/admin/users'
    | '/streams/$streamId'
    | '/admin/'
    | '/streams/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  SplatRoute: typeof SplatRoute
  AccountRoute: typeof AccountRoute
  AvatarReviewRoute: typeof AvatarReviewRoute
  CompositionsRoute: typeof CompositionsRoute
  DancefloorCommandsRoute: typeof DancefloorCommandsRoute
  FlowsRoute: typeof FlowsRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  StreamsStreamIdRoute: typeof StreamsStreamIdRoute
  StreamsIndexRoute: typeof StreamsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flows': {
      id: '/flows'
      path: '/flows'
      fullPath: '/flows'
      preLoaderRoute: typeof FlowsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dancefloor-commands': {
      id: '/dancefloor-commands'
      path: '/dancefloor-commands'
      fullPath: '/dancefloor-commands'
      preLoaderRoute: typeof DancefloorCommandsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compositions': {
      id: '/compositions'
      path: '/compositions'
      fullPath: '/compositions'
      preLoaderRoute: typeof CompositionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/avatar-review': {
      id: '/avatar-review'
      path: '/avatar-review'
      fullPath: '/avatar-review'
      preLoaderRoute: typeof AvatarReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/streams/': {
      id: '/streams/'
      path: '/streams'
      fullPath: '/streams/'
      preLoaderRoute: typeof StreamsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/streams/$streamId': {
      id: '/streams/$streamId'
      path: '/streams/$streamId'
      fullPath: '/streams/$streamId'
      preLoaderRoute: typeof StreamsStreamIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/transcripts': {
      id: '/admin/transcripts'
      path: '/transcripts'
      fullPath: '/admin/transcripts'
      preLoaderRoute: typeof AdminTranscriptsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/super-admin': {
      id: '/admin/super-admin'
      path: '/super-admin'
      fullPath: '/admin/super-admin'
      preLoaderRoute: typeof AdminSuperAdminRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/streams': {
      id: '/admin/streams'
      path: '/streams'
      fullPath: '/admin/streams'
      preLoaderRoute: typeof AdminStreamsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/recordings': {
      id: '/admin/recordings'
      path: '/recordings'
      fullPath: '/admin/recordings'
      preLoaderRoute: typeof AdminRecordingsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/live-mixer': {
      id: '/admin/live-mixer'
      path: '/live-mixer'
      fullPath: '/admin/live-mixer'
      preLoaderRoute: typeof AdminLiveMixerRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/dancefloor': {
      id: '/admin/dancefloor'
      path: '/dancefloor'
      fullPath: '/admin/dancefloor'
      preLoaderRoute: typeof AdminDancefloorRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/chat': {
      id: '/admin/chat'
      path: '/chat'
      fullPath: '/admin/chat'
      preLoaderRoute: typeof AdminChatRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/channels': {
      id: '/admin/channels'
      path: '/channels'
      fullPath: '/admin/channels'
      preLoaderRoute: typeof AdminChannelsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminChannelsRoute: typeof AdminChannelsRoute
  AdminChatRoute: typeof AdminChatRoute
  AdminDancefloorRoute: typeof AdminDancefloorRoute
  AdminLiveMixerRoute: typeof AdminLiveMixerRoute
  AdminRecordingsRoute: typeof AdminRecordingsRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminStreamsRoute: typeof AdminStreamsRoute
  AdminSuperAdminRoute: typeof AdminSuperAdminRoute
  AdminTranscriptsRoute: typeof AdminTranscriptsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminChannelsRoute: AdminChannelsRoute,
  AdminChatRoute: AdminChatRoute,
  AdminDancefloorRoute: AdminDancefloorRoute,
  AdminLiveMixerRoute: AdminLiveMixerRoute,
  AdminRecordingsRoute: AdminRecordingsRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminStreamsRoute: AdminStreamsRoute,
  AdminSuperAdminRoute: AdminSuperAdminRoute,
  AdminTranscriptsRoute: AdminTranscriptsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  SplatRoute: SplatRoute,
  AccountRoute: AccountRoute,
  AvatarReviewRoute: AvatarReviewRoute,
  CompositionsRoute: CompositionsRoute,
  DancefloorCommandsRoute: DancefloorCommandsRoute,
  FlowsRoute: FlowsRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  StreamsStreamIdRoute: StreamsStreamIdRoute,
  StreamsIndexRoute: StreamsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
